import React from 'react';
import { useTranslation } from 'react-i18next';

import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Job } from '@libs/graphql-types';

import { JobAccordion } from './JobAccordion';

const useStyles = makeStyles((theme: any) => ({
  label: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    marginBottom: theme.spacing(0.5),
  },
  value: {
    fontSize: '0.875rem',
    fontWeight: 500,
  },
}));

interface JobLocationAccordionProps {
  jobData: Job;
  expanded?: boolean;
  onChange?: (expanded: boolean) => void;
}

export const JobLocationAccordion: React.FC<JobLocationAccordionProps> = ({
  jobData,
  expanded,
  onChange,
}) => {
  const classes = useStyles();
  const { t } = useTranslation('job');

  // Extract location data from job object
  const striiveJob = jobData.striive_job;
  const locationData = {
    workSiteAddress: striiveJob?.work_site_address || 'N/A',
    workSiteCity: striiveJob?.work_site_city || 'N/A',
    workSiteStateCode: striiveJob?.work_site_state_code || 'N/A',
    postalZipCode: striiveJob?.work_site_postal_code || 'N/A',
    additionalWorkSiteAddress: striiveJob?.work_site_address2 || 'N/A',
    workSiteId: striiveJob?.work_site_record_id || 'N/A',
    workSiteCountryCode: striiveJob?.work_site_country_code || 'N/A',
  };

  const renderDetailItem = (label: string, value: string | number) => (
    <Grid item xs={12} sm={6}>
      <Typography className={classes.label}>{label}</Typography>
      <Typography className={classes.value}>{value}</Typography>
    </Grid>
  );

  return (
    <JobAccordion title={t('v2.accordion.jobLocation')} expanded={expanded} onChange={onChange}>
      <Grid container spacing={3}>
        {renderDetailItem(t('v2.accordion.workSiteAddress'), locationData.workSiteAddress)}
        {renderDetailItem(t('v2.accordion.additionalWorkSiteAddress'), locationData.additionalWorkSiteAddress)}
        {renderDetailItem(t('v2.accordion.workSiteCity'), locationData.workSiteCity)}
        {renderDetailItem(t('v2.accordion.workSiteId'), locationData.workSiteId)}
        {renderDetailItem(t('v2.accordion.workSiteStateCode'), locationData.workSiteStateCode)}
        {renderDetailItem(t('v2.accordion.workSiteCountryCode'), locationData.workSiteCountryCode)}
        {renderDetailItem(t('v2.accordion.postalZipCode'), locationData.postalZipCode)}
      </Grid>
    </JobAccordion>
  );
};
